import type { Environment } from './environment.model';

export const environment: Environment = {
  name: 'staging',
  production: false,
  apiUrl: 'https://arquitectura.staging.api.hmrs-apps.com/api/v1',
  enableLogging: true,
  defaultLanguage: 'es',
  session: {
    idleTimeoutMinutes: 30,
    warningSeconds: 120,
    keepAliveMinutes: 5,
  },
};
